import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { HttpService } from 'src/app/http.service';
import { PlayerTransactionHistoryComponent } from '../player-transaction-history/player-transaction-history.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TableComponent } from '../table/table.component';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-adjustment',
  templateUrl: './adjustment.component.html',
  styleUrls: ['./adjustment.component.scss']
})
export class AdjustmentComponent implements AfterViewInit {

  @ViewChild('search', {static: false}) search;

  public profit:any = 0;
  public table_type:any = "bank";
  public player_search:any;
  public data:any = {}
  public player:any = {}
  public players:any = [];
  public games:any = [];
  public banks:any = []; 
  public type = "invalid-entry"
  public is_loading = false;
  public is_searching_player = false
  public company_uuid:any;
  public workspacePermissions: any = {};
  public history_filter:any = { date_from: '', date_to: '' };
  searchSubject = new Subject<string>();

  @ViewChild('f', { static: false }) f : NgForm
  @ViewChild("table", { static: false }) tb: TableComponent;

  constructor(private http: HttpService, private ngbModal : NgbModal, private cdr: ChangeDetectorRef) { 
    this.company_uuid = this.http.getStaticSelectedCompany();
    this.searchSubject.pipe(
      debounceTime(500), // Adjust the debounce time (e.g., 300ms) as needed
      distinctUntilChanged()
    ).subscribe(searchText => {
      if (searchText && searchText.length >= 3) {
        this.searchPlayer(searchText);
      }
    });
  }
  
  ngAfterViewInit(): void {
    (async () => {
      this.workspacePermissions = await this.http.getHiddenPermission() || {};
      const today = this.localDate(new Date());
      this.history_filter = { date_from: today, date_to: today };
      await this.init();
      await this.switch(this.type);
      this.initTable();
    })()
  }

  async searchPlayer(data:any) {
    delete this.data.player_uuid;
    this.is_searching_player = true;
    this.players = await this.http.post("/admin/player/search", {search: data})
    this.is_searching_player = false;
  }

  async selectPlayer(player_uuid) {
    this.player_search = null;
    this.data.player_uuid = player_uuid;
    
    this.player = this.players.find((v:any) => {
      return v.uuid == player_uuid;
    })

    this.getProfit();
  }

  async init() {
    let rtn:any = await this.http.post("/admin/adjustment-init")
    this.games = rtn.games;
    this.banks = rtn.banks;

  }

  searchPlayerChange() {
    this.searchSubject.next(this.player_search);
  }

  async getProfit() {
    let pl:any = await this.http.post("/admin/player/profit", this.player);
    this.player.profit = parseFloat(pl.profit);
  }

  async submit() {

    if(this.type == "bank" && (!this.data.bank_id || this.data.bank_debit < 0 || this.data.bank_credit < 0)) {
      alert("Please select bank && value could not be negative")
      return
    }

    this.is_loading = true;
    let rtn:any = await this.http.post("/admin/group-adjustment", this.data)

    if(rtn.status) {
      this.f.resetForm({})
      await this.init();

      if(this.type == "invalid-entry") {
        this.getProfit();
      }

      
      this.switch(this.type);

    }
    this.initTable();
    this.is_loading = false;

  }

  switch(type:string) {
    this.data = {}
    
//    if (type == "invalid-entry" || type == "without-daily-sales") {
      this.data.game_id = false
  //  }

    this.data.bank_id = false
    this.data.type = type;
    this.type = type;
  }

  calculateProfit() {
    if(this.data.bank_debit) {
      this.data.profit = this.data.bank_debit;
    } else {
      this.data.profit = parseFloat(this.data.bank_credit) * -1;
    }
  }

  playerLog() {
    let modal:any = this.ngbModal.open(PlayerTransactionHistoryComponent, {size: "xl"});
    modal.componentInstance.setPlaterUUID = this.player.uuid
  }


  public async initTable(type = null) {
    if(type) {
      this.table_type = type;
    }
    const setting:any = 
        { post: {url: "/admin/setting/adjustment/get", data: {uuid: this.company_uuid, type: this.table_type}},
          disabled_pagenat: false,
          no_per_page: 100,
          filter: {...this.history_filter},
          fields: [
            {label: 'No', type: 'index'}, 
            {label: 'Date', type: 'timestamp', key: 'timestamp', filter: "string"}, 
            {label: this.capitalize(this.table_type) + ' Debit/In', type: 'price', key: 'debit', border_left: true, border_right: true}, 
            {label: this.capitalize(this.table_type) + ' Credit/Out', type: 'price', key: 'credit', border_left: true, border_right: true}, 
            {label: this.capitalize(this.table_type) + ' Balance', type: 'price', key: 'balance', border_left: true, border_right: true}, 
            {label: 'Adj Type', type: 'string', key: 'adjustment_type', border_left: true, border_right: true},
            {label: 'Remark', type: 'string', key: 'remark'}
          ]}

      this.tb.init(setting);
      this.cdr.detectChanges(); 
  }

  public searchHistory() {
    if (this.history_filter.date_from && this.history_filter.date_to && this.history_filter.date_from > this.history_filter.date_to) {
      [this.history_filter.date_from, this.history_filter.date_to] = [this.history_filter.date_to, this.history_filter.date_from];
    }
    this.initTable();
  }

  public clearHistoryDates() {
    this.history_filter = { date_from: '', date_to: '' };
    this.initTable();
  }

  private localDate(date: Date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  capitalize(s)
  {
    return s[0].toUpperCase() + s.slice(1);
  }


}
